import { useMemo } from 'react';

import { FormStructure } from '@europrocurement/flexy-form';
import { UseProductsSectionStructureProps, UseTotalsSectionStructureProps } from '../types';
import productsStructure from '../fragments/productsSection/productsStructure';
import { ExtractArrayType } from '../../../../../../utils/types';

type HeaderChildrenArrayType = ExtractArrayType<UseTotalsSectionStructureProps['headerChildren']>;

const useProductsSectionStructure = ({
    formContext,
    rubFacts,
    txTva,
    mode,
    headerSwitches,
    headerChildren,
    hasBlured,
    openModal,
    productsDetails,
    displayDetails,
    handleTotalsLock,
    stateSwitchLockValues,
}: UseProductsSectionStructureProps) => {
    const overwriteHeaderChildren = useMemo<HeaderChildrenArrayType>(() => {
        let temporaryHeaderChildren: HeaderChildrenArrayType = [];

        if (headerChildren && Array.isArray(headerChildren)) {
            temporaryHeaderChildren = [...temporaryHeaderChildren, ...headerChildren];
        } else {
            temporaryHeaderChildren.push(headerChildren);
        }

        return temporaryHeaderChildren;
    }, [headerChildren]);

    const productsSectionStructure = useMemo<Array<FormStructure>>(
        () =>
            productsStructure({
                formContext,
                rubFacts,
                txTva,
                mode,
                headerSwitches,
                headerChildren: overwriteHeaderChildren,
                hasBlured,
                openModal,
                productsDetails,
                displayDetails,
                handleTotalsLock,
                stateSwitchLockValues,
            }),
        [
            formContext,
            rubFacts,
            txTva,
            mode,
            headerSwitches,
            overwriteHeaderChildren,
            hasBlured,
            openModal,
            productsDetails,
            displayDetails,
            handleTotalsLock,
            stateSwitchLockValues,
        ],
    );

    return {
        productsSectionStructure,
    };
};

export default useProductsSectionStructure;
